export default "__VITE_ASSET__lmvAdV8v__"